// Menu: Shortlist
// 

JLM.MD.MenuShortlist = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Constants: Private _______________________________________________________
	
	// HTML structure
	const TEMPLATE_HTML = '<section class="shortlist" data-mode="view" data-tally="0"><header><div class="title"><svg class="icon"><use xlink:href="#jl_icon_shortlist"></use></svg><h2><span class="summary">Your Shortlist (<span class="tally">0</span>)</span><span class="send">Send Shortlist To</span></h2><button type="button" data-action="edit">Edit</button><button type="button" data-action="cancel">Cancel</button></div></header><div class="window"><div class="frame" data-type="results"></div><div class="frame" data-type="form"><form><fieldset id="f_shortlist_title"><legend>Shortlist Title</legend><div class="textfield"><input id="shortlist_title" type="text" value="" autocorrect="off" autocomplete="off" autocapitalize="on" spellcheck="false" placeholder="eg. Cast Shortlist for .."></div></fieldset><fieldset id="f_shortlist_sender"><legend>Your Email Address</legend><div class="textfield"><input id="shortlist_sender" type="email" value="" autocorrect="off" autocomplete="on" autocapitalize="off" spellcheck="false" placeholder="eg. me@mail.com"></div></fieldset><fieldset id="f_shortlist_recipients"><legend>Recipient Email Address/es</legend><div class="textfield"><input id="shortlist_sender" type="email" value="info@johnsonlaird.co.nz" autocorrect="off" autocomplete="on" autocapitalize="off" spellcheck="false" placeholder="eg. jane@mail.com, john@mail.com"></div><p>Tip: Separate addresses with commas</p></fieldset><fieldset id="f_shortlist_message"><legend>Message <em>(Optional)</em></legend><div class="textfield"><textarea id="shortlist_message"></textarea></div></fieldset></form></div></div><footer><div data-type="view"><button type="button" data-action="clear" disabled>Clear All</button><button type="button" data-action="next" disabled>Send…</button></div><div data-type="edit"><button type="button" data-action="done">Done</button></div><div data-type="send"><button type="button" data-action="cancel">Cancel</button><button type="button" data-action="submit" disabled>Send</button></div><div data-type="message"><p></p></div></footer></section>';
	
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let section, title_tally, 
		div_actors, div_voices, div_content_creators, div_brand_ambassadors, div_presenters, div_mcs_entertainers, div_writers_directors,
		field_title, field_sender, field_recipients, field_message, 
		footer, msg_send, but_view_clear, but_view_next, but_send_cancel, but_send_submit;
	
	// Settings
	let divisions = [],
		divisions_by_type = {},
		data_shortlist;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.tally = 0;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		JLM.database.loadTalentList( 'all', construct );
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Construct the shortlist, once talent data has loaded
	// 
	function construct() {
		// Get data
		data_shortlist = JLM.database.getShortlist();
		
		// References
		let header, frame_results, frame_form, 
			foot_view, foot_edit, foot_send, foot_message, but_title_edit, but_title_cancel, but_edit_done;
		
		// Create structure
		section = $( TEMPLATE_HTML ).appendTo( container );
		header = $('header', section);
			title_tally = $('.title h2 .tally', header);
			but_title_edit = $('button[data-action="edit"]', header);
			but_title_cancel = $('button[data-action="cancel"]', header);
		frame_results = $('.window .frame[data-type="results"]', section);
			div_actors = new JLM.MD.MenuShortlistDivision( frame_results, JLM.NS.DIVISION_ACTORS, data_shortlist[ JLM.NS.DIVISION_ACTORS ] );
			div_voices = new JLM.MD.MenuShortlistDivision( frame_results, JLM.NS.DIVISION_VOICES, data_shortlist[ JLM.NS.DIVISION_VOICES ] );
			div_content_creators = new JLM.MD.MenuShortlistDivision( frame_results, JLM.NS.DIVISION_CONTENT_CREATORS, data_shortlist[ JLM.NS.DIVISION_CONTENT_CREATORS ] );
			div_brand_ambassadors = new JLM.MD.MenuShortlistDivision( frame_results, JLM.NS.DIVISION_BRAND_AMBASSADORS, data_shortlist[ JLM.NS.DIVISION_BRAND_AMBASSADORS ] );
			div_presenters = new JLM.MD.MenuShortlistDivision( frame_results, JLM.NS.DIVISION_PRESENTERS, data_shortlist[ JLM.NS.DIVISION_PRESENTERS ] );
			div_mcs_entertainers = new JLM.MD.MenuShortlistDivision( frame_results, JLM.NS.DIVISION_MCS_ENTERTAINERS, data_shortlist[ JLM.NS.DIVISION_MCS_ENTERTAINERS ] );
			div_writers_directors = new JLM.MD.MenuShortlistDivision( frame_results, JLM.NS.DIVISION_WRITERS_DIRECTORS, data_shortlist[ JLM.NS.DIVISION_WRITERS_DIRECTORS ] );
			divisions = [ div_actors, div_voices, div_content_creators, div_brand_ambassadors, div_presenters, div_mcs_entertainers, div_writers_directors ];
			divisions_by_type[ JLM.NS.DIVISION_ACTORS ] = div_actors;
			divisions_by_type[ JLM.NS.DIVISION_VOICES ] = div_voices;
			divisions_by_type[ JLM.NS.DIVISION_CONTENT_CREATORS ] = div_content_creators;
			divisions_by_type[ JLM.NS.DIVISION_BRAND_AMBASSADORS ] = div_brand_ambassadors;
			divisions_by_type[ JLM.NS.DIVISION_PRESENTERS ] = div_presenters;
			divisions_by_type[ JLM.NS.DIVISION_MCS_ENTERTAINERS ] = div_mcs_entertainers;
			divisions_by_type[ JLM.NS.DIVISION_WRITERS_DIRECTORS ] = div_writers_directors;
		frame_form = $('.window .frame[data-type="form"]', section);
			field_title = new JLM.MD.Textfield( $('#f_shortlist_title', frame_form) );
			field_sender = new JLM.MD.Textfield( $('#f_shortlist_sender', frame_form) );
			field_recipients = new JLM.MD.Textfield( $('#f_shortlist_recipients', frame_form) );
			field_message = new JLM.MD.Textfield( $('#f_shortlist_message', frame_form) );
		footer = $('footer', section);
			foot_view = $('div[data-type="view"]', footer);
				but_view_clear = $('button[data-action="clear"]', foot_view);
				but_view_next = $('button[data-action="next"]', foot_view);
			foot_edit = $('div[data-type="edit"]', footer);
				but_edit_done = $('button[data-action="done"]', foot_edit);
			foot_send = $('div[data-type="send"]', footer);
				but_send_cancel = $('button[data-action="cancel"]', foot_send);
				but_send_submit = $('button[data-action="submit"]', foot_send);
			foot_message = $('div[data-type="message"]', footer);
				msg_send = $('p', foot_message);
		
		// Update tally
		updateTally( true );
		
		// Update footer
		footer.addClass('reveal');
		
		// Events
		frame_results.on('mousewheel', JLM.MT.preventScrollOverflow);
			divisions.forEach(function( division ) {
				division.on('remove', onTalentRemove);
			});
		frame_form.on('mousewheel', JLM.MT.preventScrollOverflow);
			field_title.on('change', checkFormFilled);
			field_sender.on('change', checkFormFilled);
			field_recipients.on('change', checkFormFilled);
			field_message.on('change', checkFormFilled);
		but_title_edit.on('click', switchModeEdit);
		but_title_cancel.on('click', switchModeView);
		but_view_clear.on('click', onTalentEmpty);
		but_view_next.on('click', function() {
			switchModeSend();
			setTimeout(function() {
				field_title.focus();
			}, 100);
		});
		but_edit_done.on('click', switchModeView);
		but_send_cancel.on('click', switchModeView);
		but_send_submit.on('click', sendShortlist);
	}
	
	
	// Event: Remove & Empty (internally)
	// 
	function onTalentRemove( talent_id, division_type ) {
		// Update internally
		removeTalent( talent_id, division_type );
		
		// Announce change
		INSTANCE.dispatchEvent('remove', [ talent_id, division_type ]);
	}
	function onTalentEmpty() {
		if ( confirm('Empty shortlist of all talent?') ) {
			// Update elements
			divisions.forEach(function( division ) {
				division.empty();
			});
			
			// Update internally
			emptyTalent();
			
			// Announce change
			INSTANCE.dispatchEvent('empty');
		}
	}
	
	
	// Actions - Add, Remove, Empty
	// 
	function addTalent( talent_id, division_type ) {
		// Add to data list
		if ( !data_shortlist[ division_type ] ) data_shortlist[ division_type ] = [];
		data_shortlist[ division_type ].push( talent_id );
		
		// Update tally
		updateTally();
		
		// Save changes
		JLM.database.setShortlist( data_shortlist );
		
		// Track
		JLM.MT.trackEvent('Add', {
			event_category: 'Shortlist',
			event_label: JSON.stringify({
				talent: talent_id,
				division: division_type
			})
		});
	}
	function removeTalent( talent_id, division_type ) {
		// If division exists in memory
		if ( data_shortlist[ division_type ] ) {
			// Remove from data list
			for( let i = 0; i < data_shortlist[ division_type ].length; i++ ) {
				if ( data_shortlist[ division_type ][i] == talent_id ) {
					data_shortlist[ division_type ].splice(i, 1);
					break;
				}
			}
			
			// Remove division if empty
			if ( data_shortlist[ division_type ].length == 0 ) {
				delete data_shortlist[ division_type ];
			}
		}
		
		// Update tally
		updateTally();
		
		// Update mode
		if ( INSTANCE.tally == 0 ) {
			switchModeView();
		}
		
		// Save changes
		JLM.database.setShortlist( data_shortlist );
		
		// Track
		JLM.MT.trackEvent('Remove', {
			event_category: 'Shortlist',
			event_label: JSON.stringify({
				talent: talent_id,
				division: division_type
			})
		});
	}
	function emptyTalent() {
		// Update data
		data_shortlist = {};
		
		// Update tally
		updateTally();
		
		// Update mode
		switchModeView();
		
		// Save changes
		JLM.database.setShortlist( data_shortlist );
		
		// Track
		JLM.MT.trackEvent('Empty', {
			event_category: 'Shortlist'
		});
	}
	
	
	// Update tally
	// 
	function updateTally( is_setup ) {
		// Calculate tally
		let tally = 0;
		divisions.forEach(function( division ) {
			tally += division.tally;
		});
		
		// If tally has changed
		let has_changed = ( tally !== INSTANCE.tally ),
			is_empty = ( tally == 0 );
		if ( has_changed ) {
			// Update visible numbers
			section.attr('data-tally', tally);
			title_tally.text( tally );
			
			// Update status
			but_view_clear.prop('disabled', is_empty);
			but_view_next.prop('disabled', is_empty);
			if ( is_empty ) switchModeView();
			
			// Update internal value
			INSTANCE.tally = tally;
			
			// Announce change
			INSTANCE.dispatchEvent('update_tally', [ tally, is_setup ]);
		}
	}
	
	
	// Modes
	// 
	function switchModeEdit() {
		// Switch mode
		section.attr('data-mode', 'edit');
		
		// If all divisions are closed, open all
		let divisions_open = false;
		divisions.forEach(function( division ) {
			divisions_open += ( division.tally > 0 && division.is_open );
		});
		if ( !divisions_open ) {
			divisions.forEach(function( division ) {
				division.open();
			});
		}
	}
	function switchModeView() {
		section.attr('data-mode', 'view');
	}
	function switchModeSend() {
		section.attr('data-mode', 'send');
	}
	function switchModeMessage() {
		section.attr('data-mode', 'message');
	}
	
	
	// When fields are updated
	// 
	function checkFormFilled() {
		if ( field_title.value && field_sender.value && field_recipients.value ) {
			but_send_submit.prop('disabled', false);
		} else {
			but_send_submit.prop('disabled', true);
		}
	}
	function validateForm() {
		let is_valid = true,
			form_values = { title: null, sender: null, recipients: null, message: null };
		
		// Title
		form_values.title = $.trim( field_title.value );
		if ( form_values.title === '' ) {
			field_title.showError();
			is_valid = false;
		}
		
		// Sender
		form_values.sender = $.trim( field_sender.value );
		if ( !JLM.MT.isValidEmailAddress( form_values.sender ) ) {
			field_sender.showError();
			is_valid = false;
		}
		
		// Recipients
		form_values.recipients = [];
		let value_recipients = field_recipients.value.split(',');
		for( let i = 0; i < value_recipients.length; i++ ) {
			let recipient = $.trim( value_recipients[i] );
			if ( JLM.MT.isValidEmailAddress( recipient ) ) {
				form_values.recipients.push( recipient );
			}
		}
		if ( !form_values.recipients.length ) {
			field_recipients.showError();
			is_valid = false;
		}
		
		// Message
		form_values.message = $.trim( field_message.value );
		
		// Response
		if ( is_valid ) {
			return form_values;
		}
		return is_valid;
	}
	
	
	// Send shortlist to server
	// 
	function sendShortlist() {
		const form_values = validateForm();
		if ( form_values ) {
			// Disable form
			disableSendForm();
			let icon = new JLM.MD.IconLoading( but_send_submit );
			
			// Add talent
			form_values.talent = data_shortlist;
			
			// Add CSRF values
			// form_values.csrf_name = $('meta[name="csrf_name"]').attr('content');
			// form_values.csrf_value = $('meta[name="csrf_value"]').attr('content');
			
			// Get CSRF values
			$.get('/api/tokens/csrf')
				.done(function( response ) {
					// Attach CSRF values
					form_values.csrf_name = response.name;
					form_values.csrf_value = response.value;
					
					// Send shortlist
					$.post('/api/shortlist/send', form_values)
						.done(function( response ) {
							if ( response.success ) {
								msg_send.text('Shortlist has been sent!');
								switchModeMessage();
								setTimeout(switchModeView, 2500);
								setTimeout(clearSendForm, 3000);
							} else {
								msg_send.text('Error: Failed to send shortlist');
								setTimeout(switchModeSend, 2500);
							}
						})
						.fail(function( event ) {
							msg_send.text('Error: Failed to connect with server');
							setTimeout(switchModeSend, 2500);
						})
						.always(function( event ) {
							icon.remove();
							enableSendForm();
						});
				})
				.fail(function( event ) {
					msg_send.text('Error: Failed to connect with server');
					setTimeout(switchModeSend, 2500);
				});
		}
	}
	
	
	// Form actions
	// 
	function disableSendForm() {
		field_title.disable();
		field_sender.disable();
		field_recipients.disable();
		field_message.disable();
		but_send_cancel.prop('disabled', true);
		but_send_submit.text('').prop('disabled', true);
	}
	function enableSendForm() {
		field_title.enable();
		field_sender.enable();
		field_recipients.enable();
		field_message.enable();
		but_send_cancel.prop('disabled', false);
		but_send_submit.text('Send').prop('disabled', false);
	}
	function clearSendForm() {
		field_title.clear();
		field_sender.clear();
		field_recipients.clear();
		field_message.clear();
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Close any current actions
	// 
	INSTANCE.close = function() {
		switchModeView();
	};
	
	
	// Add Talent (externally)
	// 
	INSTANCE.add = function( talent_id, division_type ) {
		JLM.database.getTalentInfo('all', talent_id, function( talent_info ) {
			// Add to division
			divisions_by_type[ division_type ].addTalent( talent_info );
			
			// Update internally
			addTalent( talent_id, division_type );
		});
	};
	
	
	// Remove talent (externally)
	// 
	INSTANCE.remove = function( talent_id, division_type ) {
		// Remove from division
		if ( divisions_by_type[ division_type ] ) {
			divisions_by_type[ division_type ].removeTalent( talent_id );
		}
		
		// Update internally
		removeTalent( talent_id, division_type );
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};